/*
 * Copyright (c) 2023. World Wide Generation Ltd
 */

import { generateUrl } from '../../../routes/util';
import { routes } from '../../materiality-assessment/routes/materiality-assessment-routes';
import { V6Route, V6RouteDefinition } from '../types/V6Router';

class V6Router {
  private routerMap = new Map();
  constructor(private route: V6RouteDefinition) {
    this.buildMap(this.route);
  }

  private buildMap(route: V6RouteDefinition, parentPath = ''): void {
    const fullPath = `${parentPath}/${route.path}`;

    this.routerMap.set(route.id, {
      ...route,
      path: fullPath,
    });

    route.children?.forEach(childRoute => this.buildMap(childRoute, fullPath));
  }

  getRoute(id: V6Route) {
    const route = this.routerMap.get(id);
    return {
      path: route.path,
      wildcardPath: `${route.path}/*`
    };
  }

  generateUrl(id: V6Route, params?: Record<string, string>) {
    const route = this.routerMap.get(id);
    return generateUrl({
      ...route,
      isRouterV6: true
    }, params);
  }
}

let instance: V6Router | undefined;
export const getV6Router = () => {
  if (!instance) {
    instance = new V6Router(routes);
  }
  return instance;
}
